import React from "react";
import ShapeOverlayRenderer from "./components/ShapeOverlayRenderer";

export function ShapeOverlay(base) {
  return {
    getConfig() {
      return {
        name: "ShapeOverlay",
        displayName: IdealStudio.i18n.t("ShapeOverlay.PluginName") || "Shape Overlay",
        category: "objects",
        needsConfigModal: false,
        needsTextEdition: false,
        flavor: "react",
        initialWidth: "20%",
        initialHeight: "10%",
        initialWidthSlide: "20%",
        initialHeightSlide: "10%",
        icon: "crop_square",
        allowFloatingBox: true,
      };
    },
    getToolbar(state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            shape: {
              __name: IdealStudio.i18n.t("ShapeOverlay.Shape") || "Shape",
              icon: "crop_square",
              buttons: {
                shape: {
                  __name: IdealStudio.i18n.t("ShapeOverlay.Type") || "Type",
                  type: "select",
                  value: state.shape || "rectangle",
                  options: ["rectangle", "arrow", "circle", "highlight", "blur"],
                },
                color: {
                  __name: IdealStudio.i18n.t("ShapeOverlay.Color") || "Color",
                  type: "color",
                  value: state.color || "#ef4444",
                },
              },
            },
          },
        },
      };
    },
    getRenderTemplate(state, props) {
      return (
        <ShapeOverlayRenderer
          shape={state.shape || "rectangle"}
          color={state.color || "#ef4444"}
          flipH={!!state.flipH}
          flipV={!!state.flipV}
          visor={!!props?.visor}
        />
      );
    },
  };
}
